import Config from "Config";
import { getApiClient } from "@ROM/App/ApiClient";

const API_URL = Config.API_FULL_URL;

const urls = {
  collection() {
    return "/deliveries";
  },

  resource(id) {
    return `/deliveries/${id}`;
  },

  shipping(id) {
    return `/deliveries/${id}/shipping`;
  },
};

export default {
  list(options = {}) {
    const client = getApiClient(API_URL);
    return client.get(urls.collection(), {
      params: {
        ...options,
      },
    });
  },

  find(id) {
    const client = getApiClient(API_URL);
    return client.get(urls.resource(id));
  },

  create(delivery) {
    const client = getApiClient(API_URL);
    return client.post(urls.collection(), delivery);
  },

  update(id, delivery) {
    const client = getApiClient(API_URL);
    return client.put(urls.resource(id), delivery);
  },

  updateShipping(deliveryId, deliveryShipping) {
    const client = getApiClient(API_URL);
    return client.put(urls.shipping(deliveryId), deliveryShipping);
  },

  destroy(id) {
    const client = getApiClient(API_URL);
    return client.delete(urls.resource(id));
  },
};
